import React, { FC, useEffect } from 'react';
import QuestionsContainer from '../../q-a/questions/questions-container';
import QuestionEntity from '../../../store/question-store/question-entetiy';
import { useStore } from '../../../store/store-provider';
import { QuestionState } from '../../../constans/question-enums';
import { observer } from 'mobx-react';

const PresenterQuestionListContainer: FC = () => {
  const defaultNumberOfNewQuestions = 0;
  const { questionStore, podiumInfoStore } = useStore();
  const { isReviewMode } = podiumInfoStore;
  const { getReviewList, getList, getManageQuestionNewLabel } = questionStore;
  const questionListByReviewState: QuestionEntity[] = isReviewMode ? getList(QuestionState.PRESENTER) : getReviewList();
  const numberOfNewQuestions: number = isReviewMode ?
    defaultNumberOfNewQuestions :
    getManageQuestionNewLabel().onSubscribeNewQuestionStatus(QuestionState.REVIEW);

  useEffect(() => {
    questionStore.getQuestionList();
  }, []);

  return (
    <QuestionsContainer questions={questionListByReviewState} numberOfNewQuestions={numberOfNewQuestions}/>
  );
};

export default observer(PresenterQuestionListContainer);
